<template>
    <div class="container">
        <h5 class="mt-3 mb-3">Please Share your information to perk provider</h5>
        <div class="enquiry-form mb-3" v-if="user">
            <form class="mb-3">
                <div class="form-group">
                    <label for="name">Name:</label>
                    <input type="text" name="name" :value="user.name" class="form-control">
                </div>
                <div class="form-group">
                    <label for="email">Email:</label>
                    <input type="text" name="email" :value="user.email" class="form-control">
                </div>
                <div class="form-group" v-if="user.city">
                    <label for="address">City:</label>
                    <input type="text" name="address" :value="user.city.name" class="form-control">
                </div>
                <div class="form-group">
                    <label for="company">Company:</label>
                    <input type="text" name="company" :value="user.company.name" class="form-control">
                </div>
            </form>
            <button type="submit" @click="submitAction" class="btn btn-primary d-inline-block mt-4">Submit</button>
        </div>
    </div>
</template>

<script>

export default {

    props: {
        user: {
            type: Object
        },
        submitAction: Function
    },
}
</script>
